import axios from 'axios';
import { DEFAULT_AXIOS_CONFIG } from './userService';
import { resolveGatewayBackedServiceBaseUrl } from './serviceBaseUrl';

const HEALTH_SERVICE_URL = resolveGatewayBackedServiceBaseUrl(process.env.REACT_APP_HEALTH_SERVICE_URL);

export const fetchSystemHealth = async () => {
    const response = await axios.get(
        `${HEALTH_SERVICE_URL}/api/health/system`,
        DEFAULT_AXIOS_CONFIG
    );
    return response.data;
};

export const fetchServiceHistory = async (serviceId, params = {}) => {
    if (!serviceId) {
        throw new Error('serviceId is required');
    }
    const query = new URLSearchParams();
    if (params.range) {
        query.append('range', params.range);
    } else {
        if (params.from) {
            query.append('from', params.from);
        }
        if (params.to) {
            query.append('to', params.to);
        }
    }
    if (params.maxSamples) {
        query.append('maxSamples', params.maxSamples);
    }
    const queryString = query.toString();
    const url = `${HEALTH_SERVICE_URL}/api/health/system/history/${encodeURIComponent(serviceId)}${queryString ? `?${queryString}` : ''}`;
    const response = await axios.get(url, DEFAULT_AXIOS_CONFIG);
    return response.data;
};

const systemHealthService = {
    fetchSystemHealth,
    fetchServiceHistory,
};

export default systemHealthService;
